import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Features.css';

const ICONS = [
  <path key="cost" d="M12 2v20M17 6.5c0-1.9-2.2-3.5-5-3.5S7 4.6 7 6.5 9.2 10 12 10s5 1.6 5 3.5-2.2 3.5-5 3.5-5-1.6-5-3.5" />,
  <path key="quality" d="m20 6-11 11-5-5" />,
  <path key="flex" d="M4 12h16M4 12a4 4 0 0 1 4-4h1M4 12a4 4 0 0 0 4 4h1M20 12a4 4 0 0 0-4-4h-1M20 12a4 4 0 0 1-4 4h-1" />,
];

export default function Features() {
  const { t } = useLanguage();

  return (
    <section className="section section--alt features">
      <div className="container">
        <div className="section-head section-head--center">
          <h2 className="section-title">{t.features.title}</h2>
        </div>
        <div className="features__grid">
          {t.features.items.map((item, i) => (
            <div className="feature-card" key={item.title}>
              <span className="feature-card__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {ICONS[i]}
                </svg>
              </span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
